import { Tag, TagProps } from 'antd';
import { Trans } from 'react-i18next';

import { RecruitmentProcessCollection } from '../../types';

interface RecruitmentProcessStatusProps extends TagProps {
  status: RecruitmentProcessCollection['status'];
}

const RecruitmentProcessStatus = ({ status, ...props }: RecruitmentProcessStatusProps) => {
  return (
    <>
      {status === 'ACTIVE' && (
        <Tag color="success" data-testid="recruitment-process-status-active" {...props}>
          <Trans>Ativo</Trans>
        </Tag>
      )}
      {status === 'INACTIVE' && (
        <Tag color="error" data-testid="recruitment-process-status-inactive" {...props}>
          <Trans>Reprovado</Trans>
        </Tag>
      )}
      {status === 'GIVEN_UP' && (
        <Tag color="warning" data-testid="recruitment-process-status-givenup" {...props}>
          <Trans>Desistente</Trans>
        </Tag>
      )}
    </>
  );
};

export default RecruitmentProcessStatus;
